import React from 'react';
import type { MutableRefObject } from 'react';
import type { Nullable } from 'corgi-types';
import type { SpaceProps } from 'styled-system';

import type { MessageType } from '../../enums/Alert';
import AutoScrollAlert from './index';

interface AutoScrollDrawerAlert extends SpaceProps {
  message: string;
  messageId: number;
  containerRef: MutableRefObject<Nullable<HTMLElement>>;
  type?: MessageType;
}

const AutoScrollDrawerAlert = (props: AutoScrollDrawerAlert) => (
  <AutoScrollAlert
    scrollOnError
    trackImpression
    mt={['sp_20', 'sp_24']}
    mb={['sp_0', 'sp_4', 'sp_8']}
    mx="sp_16"
    {...props}
  />
);

export default AutoScrollDrawerAlert;
